export default {
  printOrder: {
    icon: require("@/assets/i/orden-w.svg"),
    iconHover: require("@/assets/i/orden-b.svg"),
    titleEs: "Órdenes de impresión",
    titleEn: "Print Orders",
    menu: "printer",
    children: [
      {
        titleEs: "Órdenes",
        titleEn: "Orders",
        to: "/cixxonia-printer/orders"
      },
      {
        titleEs: "Agregar nueva orden por csv",
        titleEn: "Add new order from csv",
        to: "/cixxonia-printer/orders/add",
        roles: [1, 2, 3, 4]
      },
      {
        titleEs: "Agregar nueva orden manual",
        titleEn: "Add new order manually",
        to: "/cixxonia-printer/orders/add-manual",
        roles: [1, 2, 3, 4]
      }
    ]
  },
  printers: {
    icon: require("@/assets/i/icon-printer-w.svg"),
    iconHover: require("@/assets/i/icon-printer.svg"),
    titleEs: "Impresoras",
    titleEn: "Printers",
    menu: "printer",
    children: [
      {
        titleEs: "Impresoras",
        titleEn: "Printers",
        to: "/printer/all"
      },
      {
        titleEs: "Agregar nueva impresora",
        titleEn: "Add new printer",
        to: "/printer/add",
        roles: [1]
      },
    ]
  },
};
